// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Main_wrapper__34kf0","maxWidth":"Main_maxWidth__39OfN","center":"Main_center__1sDjw"};